import { isNotDefined } from '@sgme/fp';
import { Tooltip } from '@sgme/ui';
import type { ReactElement } from 'react';
import { useIntl } from 'react-intl';

import type { OmsFieldError } from '@/types/common.ts';
import type { IntlMessageId } from '@/types/intl';

type Props = {
  children: ReactElement | ReactElement[];
  errors: OmsFieldError | undefined;
};

// displays an error tooltip if the errorI18nKey prop is defined
// destined to have an input element as child
export const OmsFieldErrorWrapper = ({ errors, children }: Props) => {
  const { formatMessage } = useIntl();

  if (isNotDefined(errors)) {
    return children;
  }

  const contents = formatMessage({
    id: `error-oms-${errors.errorCode}` as IntlMessageId,
    defaultMessage: errors.errorDescription ?? '(no description)',
  });

  return (
    <div className="position-relative">
      <Tooltip initialOpen contents={contents} position="right" color="danger">
        <div>{children}</div>
      </Tooltip>
    </div>
  );
};
